import { api } from "../api";
export const missionsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getMissions: build.query({
            query: (args) => {
                const baseUrl = args.isPreview
                    ? `accrual-mission-service/api/v1/widget/preview/missions`
                    : `accrual-mission-service/api/v1/widget/user/missions`;
                return {
                    url: baseUrl,
                    headers: {
                        "X-Loyalty-Language": (args.locale).split('-')[0],
                        Authorization: `Bearer ${args.jwt}`,
                    },
                };
            },
            forceRefetch: () => true,
        }),
        clickOnMissionCta: build.mutation({
            query: (args) => ({
                url: `accrual-mission-service/api/v1/widget/user/missions/${args.missionCode}/click-on-cta`,
                method: 'POST',
                headers: {
                    "X-Loyalty-Language": (args.locale).split('-')[0],
                    Authorization: `Bearer ${args.jwt}`,
                },
            }),
        }),
        getSurvey: build.query({
            query: (args) => ({
                url: `accrual-mission-service/api/v1/widget/missions/${args.missionCode}/survey`,
                headers: {
                    "X-Loyalty-Language": (args.locale).split('-')[0],
                    Authorization: `Bearer ${args.jwt}`,
                },
            }),
        }),
        submitSurveyAnswers: build.mutation({
            query: (args) => ({
                url: `accrual-mission-service/api/v1/widget/user/missions/${args.missionCode}/survey/answers`,
                method: 'POST',
                headers: {
                    "X-Loyalty-Language": (args.locale).split('-')[0],
                    Authorization: `Bearer ${args.jwt}`,
                    "Content-Type": "application/json",
                },
                body: args.answers,
            }),
        }),
    }),
});
//# sourceMappingURL=missions.api.js.map